import { FC } from "react";
import { ResponsiveContainer, Sankey, Tooltip } from "recharts";
import { formatYAxis, IAiChart, ISankeyChartConfig } from "./chartConfig";
import { customTokens } from "../../theme/theme";

const transformData = (data: any, config: ISankeyChartConfig) => {
  const nodes: { name: string }[] = [];
  const links: { source: number; target: number; value: number }[] = [];

  const getNodeIndex = (name: string) => {
    let idx = nodes.findIndex((n) => n.name === name);
    if (idx === -1) {
      idx = nodes.length;
      nodes.push({ name });
    }
    return idx;
  };

  config.data.levels.forEach((level) => {
    data.forEach((d: any) => {
      const sourceVal = d[level.source.field as keyof typeof d] as string;
      const targetVal = d[level.target.field as keyof typeof d] as string;
      const valueVal = d[level.value.field as keyof typeof d] as number;

      const sourceIdx = getNodeIndex(sourceVal);
      const targetIdx = getNodeIndex(targetVal);

      links.push({
        source: sourceIdx,
        target: targetIdx,
        value: valueVal,
      });
    });
  });

  return { nodes, links };
};

const CustomNode = (props: any) => {
  const { x, y, width, height, payload } = props;

  return (
    <g>
      {/* Rectangle for the node */}
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={customTokens.UNFCCCBrandGraphLevel1}
        stroke={customTokens.fontDarkGrayBody}
        strokeWidth={1}
      />
      {/* Label */}
      <text
        x={x + width + 6}
        y={y + height / 2}
        textAnchor="start"
        alignmentBaseline="middle"
        fill={customTokens.fontDarkGrayBody}
        fontSize={14}
        fontWeight={700}
      >
        {payload.name}
      </text>
    </g>
  );
};

const AiSankeyChart: FC<IAiChart> = ({ config, chartData }) => {
  const { nodes, links } = transformData(
    chartData,
    config as ISankeyChartConfig
  );

  return (
    <ResponsiveContainer width="100%" height={400}>
      <Sankey
        width={800}
        height={500}
        data={{ nodes, links }}
        node={<CustomNode />}
        link={{ stroke: customTokens.UNFCCCBrandGraphLevel1 }}
      >
        <Tooltip formatter={(v) => formatYAxis(v)} />
      </Sankey>
    </ResponsiveContainer>
  );
};

export default AiSankeyChart;
